module.exports = __webpack_public_path__ + "img/btn-cover.28d8b3ac.svg";